const E401_Title = "Session timed out";
const E401_Msg = "Please login again";

export const SaveExtractErrMsg = {
  E412: {
    title: "Name already exists",
    msg: "Please enter a unique name to save the extract.",
  },
  E409: {
    title: "Name already Exists",
    msg: "Please enter the unique name for the extract"
  },
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E415: {
    title: "Unsupported media type - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal server error - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const CommonErrMsg = {
  E404: {
    title: "Record Not found",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E400: {
    title: "Bad Request",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E415: {
    title: "Unsupported Media Type",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E409: {
    title: "Name already Exists",
    msg: "Please enter the unique tag name for the config"
  },
  Empty: {
    title: "Unhandled Exception",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  }
};

export const OutputConfigErrMsg = {
  E404: {
    title: "Record Not found - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E400: {
    title: "Bad Request - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E415: {
    title: "Unsupported Media Type - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const EditOutputConfigErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const SaveBandingErrMsg = {
  E404: {
    title: "Record Not found - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E422: {
    title: "Band name already exists",
    msg: "Band name is already available is existing banding details",
  },
  E500: {
    title: "Internal Server Error - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const EditBandingErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const GetOutConfigListErrMsg = {
  E404: {
    title: "Record Not found - Output config list",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E415: {
    title: "Unsupported Media Type - Output config list",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Output config list",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Output config list",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const GetBandingErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const SaveMapOutputDetailErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Output detail",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Output detail ",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Output detail",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E409: {
    title: "Tag name already Exists",
    msg: "Please enter the unique tag name for the config"
  }
};

export const EditMappingDetailErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const GetMappingDetailErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const DeleteBandingDetailErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Banding",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const DeleteOutputMappingDetailErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Output mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Output mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Output mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};
export const GetMappedStatusErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Mapping",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};
export const DeleteOutputConfigErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity -Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Output configuration",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const GetExtractListErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E422: {
    title: "Unprocessable Entity - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Erro - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const ExtractDetailErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const ExecuteExtractErrMsg = {
  E404: {
    title: "Record Not found - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E415: {
    title: "Unsupported Media Type - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator"
  },
  E422: {
    title: "Unprocessable Entity - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E424: {
    title: "Extract Execution Error - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const ExportExtractErrMsg = {
  E404: {
    title: "Record Not found - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E415: {
    title: "Unsupported Media Type - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entit - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const GetExportedExtractErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Extract",
    msg: "Record Not found",
  },
  E422: {
    title: "Unprocessable Entity - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },

};
export const SaveScheduleConfigErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E415: {
    title: "Unsupported Media Type - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E412: {
    title: "Name already exists",
    msg: "Please enter a unique name to save the schedule.",
  },
  E500: {
    title: "Internal Server Error - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const DeleteExtractScheduleErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const DeleteExtractErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Extract",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const UpdateExtractErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E422: {
    title: "Validation Failed",
    msg: "Name field should not be empty",
  },
  E500: {
    title: "Update artefact details failed",
    msg: "An unknown error occurred whilst updating artefact details",
  },
};

export const GetScheduleListErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const CreateExtractVersionErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "No artefacts found",
    msg: "Version cannot be created. Please add artefact in order to add version"
  },
  E415: {
    title: "Unsupported Media Type - Version",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Version",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Version",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const UpdateExtractScheduleInstanceErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E404: {
    title: "Record Not found - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E422: {
    title: "Unprocessable Entity - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const VersionListErrMessage = {
  E422: {
    title: "Unprocessable Entity - Schedule",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - Version",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  }
};

export const GetMkbVersionDetailsErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E500: {
    title: "Internal Server Error - Activation status",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  }
};

export const OptOutErrMsg = {
  E401: {
    title: E401_Title,
    msg: E401_Msg
  },
  E422: {
    title: "Unprocessable Entity - OptOut",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
  E500: {
    title: "Internal Server Error - OptOut",
    msg: "Please refresh the application. If problem persists, please contact the system administrator",
  },
};

export const ErrorMessageGroup = {
  "SaveExtractErrMsg": SaveExtractErrMsg,
  "OutputConfigErrMsg": OutputConfigErrMsg,
  "EditOutputConfigErrMsg": EditOutputConfigErrMsg,
  "SaveBandingErrMsg": SaveBandingErrMsg,
  "EditBandingErrMsg": EditBandingErrMsg,
  "GetOutConfigListErrMsg": GetOutConfigListErrMsg,
  "GetBandingErrMsg": GetBandingErrMsg,
  "SaveMapOutputDetailErrMsg": SaveMapOutputDetailErrMsg,
  "EditMappingDetailErrMsg": EditMappingDetailErrMsg,
  "GetMappingDetailErrMsg": GetMappingDetailErrMsg,
  "DeleteBandingDetailErrMsg": DeleteBandingDetailErrMsg,
  "DeleteOutputMappingDetailErrMsg": DeleteOutputMappingDetailErrMsg,
  "GetMappedStatusErrMsg": GetMappedStatusErrMsg,
  "DeleteOutputConfigErrMsg": DeleteOutputConfigErrMsg,
  "GetExtractListErrMsg": GetExtractListErrMsg,
  "ExtractDetailErrMsg": ExtractDetailErrMsg,
  "ExecuteExtractErrMsg": ExecuteExtractErrMsg,
  "ExportExtractErrMsg": ExportExtractErrMsg,
  "GetExportedExtractErrMsg": GetExportedExtractErrMsg,
  "SaveScheduleConfigErrMsg": SaveScheduleConfigErrMsg,
  "DeleteExtractScheduleErrMsg": DeleteExtractScheduleErrMsg,
  "DeleteExtractErrMsg": DeleteExtractErrMsg,
  "UpdateExtractErrMsg": UpdateExtractErrMsg,
  "GetScheduleListErrMsg": GetScheduleListErrMsg,
  "CreateExtractVersionErrMsg": CreateExtractVersionErrMsg,
  "UpdateExtractScheduleInstanceErrMsg": UpdateExtractScheduleInstanceErrMsg,
  "CommonErrMsg": CommonErrMsg,
  "VersionListErrMessage": VersionListErrMessage,
  "OptOutErrMsg": OptOutErrMsg,
  "GetMkbVersionDetailsErrMsg": GetMkbVersionDetailsErrMsg
};
